import { render } from "./userActivations.vue?vue&type=template&id=5395312d"
import script from "./userActivations.vue?vue&type=script&lang=js"
export * from "./userActivations.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__